import React from "react";

const ModelView2 = ({
  tableContent,
  tableHeaders,
  customHeader = [],
  customFooter = [],
}) => {
  if (!tableContent || !tableHeaders) {
    return <p>No data available</p>;
  }

  return (
    <table
      style={{ width: "100%", borderCollapse: "collapse", textAlign: "center" }}
    >
      {/* Custom Header */}
      {customHeader.length > 0 && (
        <thead>
          {customHeader.map((headerRow, index) => (
            <tr
              key={index}
              style={{ backgroundColor: "#f44336", color: "#fff" }}
            >
              {Object.values(headerRow).map((cell, idx) => (
                <th
                  key={idx}
                  style={{ padding: "10px", border: "1px solid #fff" }}
                >
                  {cell}
                </th>
              ))}
            </tr>
          ))}
        </thead>
      )}

      {/* Table Headers */}
      <thead>
        <tr style={{ backgroundColor: "#f44336", color: "#fff" }}>
          {tableHeaders.map((header, index) => (
            <th
              key={index}
              style={{ padding: "10px", border: "1px solid #fff" }}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>

      {/* Table Content */}
      <tbody>
        {tableContent.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {Object.entries(row).map(([key, value], cellIndex) => (
              <td
                key={cellIndex}
                style={{
                  padding: "10px",
                  border: "1px solid #000",
                  backgroundColor:
                    key === "oshma"
                      ? "#ffa2a2"
                      : key === "emaili"
                      ? "#c0deff"
                      : "transparent",
                }}
              >
                {value}
              </td>
            ))}
          </tr>
        ))}
      </tbody>

      {/* Custom Footer */}
      {customFooter.length > 0 && (
        <tfoot>
          {customFooter.map((footerRow, index) => (
            <tr
              key={index}
              style={{ backgroundColor: "#f44336", color: "#fff" }}
            >
              {Object.values(footerRow).map((cell, idx) => (
                <td
                  key={idx}
                  style={{ padding: "10px", border: "1px solid #fff" }}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tfoot>
      )}
    </table>
  );
};

export default ModelView2;
